import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import PageTitle from "../components/PageTitleCompoent";
import "../css/AddPackage.css";
import api from "../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddBoardingPackage() {
  const navigate = useNavigate();

  const [packageName, setPackageName] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [duration, setDuration] = useState("");
  const [amount, setAmount] = useState("");
  const [subscribedAmount, setSubscribedAmount] = useState("");

  const handleSave = async () => {
    if (!packageName.trim()) {
      toast.error("Please enter package name");
      return;
    }
    if (!amount.trim() || !subscribedAmount.trim()) {
      toast.error("Please enter both price and subscribed offer price");
      return;
    }

    const newPackage = {
      package_name: packageName.trim(),
      sub_title: subtitle.trim(),
      duration: duration.trim(),
      package_amount: parseFloat(amount),
      subscribed_user_offer_amount: parseFloat(subscribedAmount),
      services: "",
      tags: "",
    };

    try {
      await api.post("/boarding-packages/", newPackage);
      toast.success("Package saved successfully!");
      setTimeout(() => navigate(-1), 1500);
    } catch (error) {
      console.error("Error saving boarding package:", error);
      toast.error("Failed to save package. Please check inputs.");
    }
  };

  return (
    <div className="Add-package-container">
      <Sidebar />
      <div className="Add-package-main">
        <Header />
        <motion.div
          className="Add-package-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <PageTitle title="Add Package" onBack={() => navigate(-1)} />

          <div className="Add-package-grid">
            {/* Package Name & Subtitle */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Package Name</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={packageName}
                  onChange={(e) => setPackageName(e.target.value)}
                  placeholder="Enter Package Name..."
                  style={{ width: "65%" }}
                />
              </div>
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Subtitle</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={subtitle}
                  onChange={(e) => setSubtitle(e.target.value)}
                  placeholder="Enter Subtitle..."
                  style={{ width: "65%" }}
                />
              </div>
            </div>

            {/* Duration */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Duration</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  placeholder="Enter Duration..."
                  style={{ width: "31.5%" }}
                />
              </div>
            </div>

            {/* Amount & Subscribed Amount */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Package Amount</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter Amount..."
                  style={{ width: "65%" }}
                />
              </div>
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">
                    Subscribed User Offer Amount
                  </h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={subscribedAmount}
                  onChange={(e) => setSubscribedAmount(e.target.value)}
                  placeholder="Enter Offer Amount..."
                  style={{ width: "65%" }}
                />
              </div>
            </div>

            {/* Save Button */}
            <div className="Add-package-button-wrapper">
              <button
                className="Add-package-save-button"
                onClick={handleSave}
                type="button"
              >
                Save
              </button>
            </div>
          </div>
        </motion.div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
